import React from 'react';
import update from 'react-addons-update';
import Collapsible from 'react-collapsible';
import Carousel from 'nuka-carousel';

import Tile from './../tiles/tile';
import classnames from 'classnames';

import FloatPanel from './../panels/FloatPanel';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-100475676-1');

class CompareCover extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      DCdata: [
        {key: 1, amount: 100000, premium: '', tileType: 'dc', id: 1, checked: false},
        {key: 2, amount: 200000, premium: '', tileType: 'dc', id: 2, checked: false},
        {key: 3,  amount: 300000, premium: '', tileType: 'dc', id: 3, checked: false}
      ],
      TPDdata: [
        {key: 4, amount: 100000, premium: '', tileType: 'tpd', id: 4, checked: false},
        {key: 5, amount: 200000, premium: '', tileType: 'tpd', id: 5, checked: false},
        {key: 6,  amount: 300000, premium: '', tileType: 'tpd', id: 6, checked: false}
      ],
      IPdata: [
        {key: 7, amount: 100000, premium: '', tileType: 'ip', protectionLength: '2', id: 7, checked: false},
        {key: 8, amount: 200000, premium: '', tileType: 'ip', protectionLength: '5', id: 8, checked: false},
        {key: 9,  amount: 300000, premium: '', tileType: 'ip', protectionLength: '65', id: 9, checked: false}
      ],
      stations : [
        {call:'station one',frequency:'000'},
        {call:'station two',frequency:'001'}
      ],
      insuranceCoverInputs: {

      },
      selections: [],
      results:{
        premiumDCTotal: '',
        premiumTPDTotal: '',
        premiumDCIsCheaper: '',
        premiumDCIsExpensive: ''
      },
      premium: 52.1429,
      premiumFrequency: 'per week',
      amountDC: '0',
      premiumDC:'0',
      amountTPD: '0',
      premiumTPD: '0',
      amountIP: '0',
      premiumIP: '0'
    };

    this.handleTileSelectDC = this.handleTileSelectDC.bind(this);
    this.handleTileSelectTPD = this.handleTileSelectTPD.bind(this);
    this.handleTileSelectIP = this.handleTileSelectIP.bind(this);

    this.handlePremiumChange = this.handlePremiumChange.bind(this);
    this.update = this.update.bind(this);
    this.onChildToggle = this.onChildToggle.bind(this);
  }

  componentDidMount() {
    this.calculateEverything();
  }

  componentWillReceiveProps(nextProps, nextState){
    // TODO setState(update$set all premiumDC/premiumTPD/premiumIP values)
    // TODO fix edit and return back to see two checked

    if(this.props.step1Inactive === true && nextProps.step2Inactive === true) {
      // need to calculate before setting
      // tile with user input checked
      this.calculateEverything();


      let DCnodes = this.state.DCdata,
          DCkeys = Object.keys(DCnodes);
      for (let i = 0; i < DCkeys.length; i++) {
        let DCnode = DCnodes[DCkeys[i]];
        if (DCnode.amount === this.props.insuranceCoverInputs.deathCover) {
            DCnode.checked = true;
        } else {
          DCnode.checked = false;
        }
      }

      let TPDnodes = this.state.TPDdata,
          TPDkeys = Object.keys(TPDnodes);
      for (let i = 0; i < TPDkeys.length; i++) {
        let TPDnode = TPDnodes[TPDkeys[i]];
        if (TPDnode.amount === this.props.insuranceCoverInputs.tpdCover) {
            TPDnode.checked = true;
        } else {
          TPDnode.checked = false;
        }
      }

      let IPnodes = this.state.IPdata,
          IPkeys = Object.keys(IPnodes);
      for (let i = 0; i < IPkeys.length; i++) {
        let IPnode = IPnodes[IPkeys[i]];
        if(this.props.insuranceCoverInputs.itemsProtectionLength === IPnode.protectionLength) {
          IPnode.checked = true;
          this.setState({
            IPprotectionLength: IPnode.protectionLength
          });
        } else if(this.props.userInputs.police === '1'){
          this.setState({
            IPprotectionLength: '2'
          });
          IPnode.checked = true;
        } else {
          IPnode.checked = false;
        }
      }
    }

      // run calcuation on the user inputs
      if(this.props.insuranceCoverInputs.deathCover > '1' || this.props.insuranceCoverInputs.ipCover > '1' || this.props.insuranceCoverInputs.tpdCover > '1'){
        this.calculateEverything();
        return true;
      }
      return false;
  }

  handlePremiumChange(e) {
    let premiumFQ = '';
    if(e == '52.1429'){
      //weekly
      premiumFQ = 'per week';
    }else if(e == '26.0715'){
      //fontnight
      premiumFQ = 'per fortnight';
    }else if(e == '12'){
      //monthly
      premiumFQ = 'per month';
    }else if(e == '1'){
      //yearly
      premiumFQ = 'per year';
    }

    this.setState({
      premium: e,
      premiumFrequency: premiumFQ
    }, () => this.calculateEverything());
  }

  onChildToggle(id, selected) {
       let selections = this.state.selections;

       selections[id] = selected;

       this.setState({
           selections: selections
       });
   }

   roundToX(num, x) {
     return +(Math.round(+(num.toString() + 'e' + x)).toString() + 'e' + -x);
   }

   calculateEverything() {

    const ocData = require("!json!../../data/occupationalRating.json");
    let calculateDCPremium = '',
        calculateTPDPremium = '',
        calculateDCIsCheaper = '',
        calculateDCIsExpensive = '',
        calculateTPDIsCheaper = '',
        calculateTPDIsExpensive = '',

        calculateIP3Y30Day = '',
        calculateIP3Y60Day = '',
        calculateIP3Y90Day = '',

        calculateIP5Y30Day = '',
        calculateIP5Y60Day = '',
        calculateIP5Y90Day = '',

        calculateIP65Y30Day = '',
        calculateIP65Y60Day = '',
        calculateIP65Y90Day = '',

        calculateIPPolicePremium = '';


    const DCitems = this.state.DCdata;
    
    if(this.props.insuranceCoverInputs.deathCover < 150000) {
      DCitems[0].amount = this.props.insuranceCoverInputs.deathCover;
      DCitems[1].amount = +this.props.insuranceCoverInputs.deathCover + +100000;
      DCitems[2].amount = +this.props.insuranceCoverInputs.deathCover + +200000;
    } else if(this.props.insuranceCoverInputs.deathCover > 2900000) {
      DCitems[0].amount = this.props.insuranceCoverInputs.deathCover - 200000;
      DCitems[1].amount = this.props.insuranceCoverInputs.deathCover - 100000;
      DCitems[2].amount = this.props.insuranceCoverInputs.deathCover;
    } else {
      DCitems[0].amount = this.props.insuranceCoverInputs.deathCover - 100000;
      DCitems[1].amount = this.props.insuranceCoverInputs.deathCover;
      DCitems[2].amount = +this.props.insuranceCoverInputs.deathCover + +100000;
    }

    const TPDitems = this.state.TPDdata;

    if(this.props.insuranceCoverInputs.tpdCover < 150000) {
      TPDitems[0].amount = this.props.insuranceCoverInputs.tpdCover;
      TPDitems[1].amount = +this.props.insuranceCoverInputs.tpdCover + +100000;
      TPDitems[2].amount = +this.props.insuranceCoverInputs.tpdCover + +200000;
    } else if(this.props.insuranceCoverInputs.tpdCover > 2900000){
      TPDitems[0].amount = this.props.insuranceCoverInputs.tpdCover - 200000;
      TPDitems[1].amount = this.props.insuranceCoverInputs.tpdCover - 100000;
      TPDitems[2].amount = this.props.insuranceCoverInputs.tpdCover;
    } else {
      TPDitems[0].amount = this.props.insuranceCoverInputs.tpdCover - 100000;
      TPDitems[1].amount = this.props.insuranceCoverInputs.tpdCover;
      TPDitems[2].amount = +this.props.insuranceCoverInputs.tpdCover + +100000;
    }


    const IPitems = this.state.IPdata;

    if(this.props.userInputs.police !== '0') {      
      IPitems[0].amount = this.props.insuranceCoverInputs.ipCover;      
    } else {
      IPitems[0].amount = this.props.insuranceCoverInputs.ipCover;
      IPitems[1].amount = this.props.insuranceCoverInputs.ipCover;
      IPitems[2].amount = this.props.insuranceCoverInputs.ipCover;  
    }
    


    for (let i = 0; i < ocData.length; i++) {
      if(ocData[i].oRating == this.props.userInputs.occupationalRating) {
        if (this.props.userInputs.police === '0') {
          const data = require("!json!../../data/standardRateFixed.json");
          for (let j = 0; j < data.length; j++) {
            if(data[j].age === this.props.userInputs.age) {
              if(this.props.insuranceCoverInputs.deathCover != null) {

                let RoundUpDecimal = data[j].dc * ocData[i].Death;
                RoundUpDecimal = this.roundToX(RoundUpDecimal, 2);

                if(this.props.insuranceCoverInputs.deathCover < 150000) {
                  calculateDCIsCheaper = this.props.insuranceCoverInputs.deathCover / 1000 * RoundUpDecimal / this.state.premium;
                  calculateDCPremium = DCitems[1].amount / 1000 * RoundUpDecimal / this.state.premium;
                  calculateDCIsExpensive = DCitems[2].amount / 1000 * RoundUpDecimal / this.state.premium;
                } else if(this.props.insuranceCoverInputs.deathCover > 2900000) {
                  calculateDCIsCheaper = DCitems[0].amount / 1000 * RoundUpDecimal / this.state.premium;
                  calculateDCPremium = DCitems[1].amount / 1000 * RoundUpDecimal / this.state.premium;
                  calculateDCIsExpensive = this.props.insuranceCoverInputs.deathCover / 1000 * RoundUpDecimal / this.state.premium;

                } else {
                  calculateDCIsCheaper = DCitems[0].amount / 1000 * RoundUpDecimal / this.state.premium;
                  calculateDCPremium = this.props.insuranceCoverInputs.deathCover / 1000 * RoundUpDecimal / this.state.premium;
                  calculateDCIsExpensive = DCitems[2].amount / 1000 * RoundUpDecimal / this.state.premium;
                }



                this.setState({data: data, age: this.props.userInputs.age, dc: data[j].dc, tpd: data[j].tpd});
                DCitems[0].premium = this.roundToX(calculateDCIsCheaper, 2);
                DCitems[1].premium = this.roundToX(calculateDCPremium, 2);
                DCitems[2].premium = this.roundToX(calculateDCIsExpensive, 2);
              }
              if(this.props.insuranceCoverInputs.tpdCover != null) {

                let RoundUpDecimal = this.roundToX(data[j].tpd * ocData[i].TPD, 3);

                RoundUpDecimal = this.roundToX(RoundUpDecimal, 2);
                if(this.props.insuranceCoverInputs.tpdCover < 150000) {
                  calculateTPDIsCheaper = this.props.insuranceCoverInputs.tpdCover / 1000 * RoundUpDecimal / this.state.premium;
                  calculateTPDPremium = TPDitems[1].amount / 1000 * RoundUpDecimal / this.state.premium;
                  calculateTPDIsExpensive = TPDitems[2].amount / 1000 * RoundUpDecimal / this.state.premium;
                } else if(this.props.insuranceCoverInputs.tpdCover > 2900000){
                  calculateTPDIsCheaper = TPDitems[0].amount / 1000 * RoundUpDecimal / this.state.premium;
                  calculateTPDPremium = TPDitems[1].amount / 1000 * RoundUpDecimal / this.state.premium;
                  calculateTPDIsExpensive = this.props.insuranceCoverInputs.tpdCover / 1000 * RoundUpDecimal / this.state.premium;
                } else {
                  calculateTPDIsCheaper = TPDitems[0].amount / 1000 * RoundUpDecimal / this.state.premium;
                  calculateTPDPremium = this.props.insuranceCoverInputs.tpdCover / 1000 * RoundUpDecimal / this.state.premium;
                  calculateTPDIsExpensive = TPDitems[2].amount / 1000 * RoundUpDecimal / this.state.premium;
                }



                this.setState({data: data, age: this.props.userInputs.age, dc: data[j].dc, tpd: data[j].tpd});
                TPDitems[0].premium = this.roundToX(calculateTPDIsCheaper, 2);
                TPDitems[1].premium = this.roundToX(calculateTPDPremium, 2);
                TPDitems[2].premium = this.roundToX(calculateTPDIsExpensive, 2);
              }
            }
          }
        } else if(this.props.userInputs.police === '1') {

          const data = require("!json!../../data/highRiskFixedRatePolice.json");

          for (let i = 0; i < data.length; i++) {
            if(data[i].age === this.props.userInputs.age) {
              if(this.props.insuranceCoverInputs.deathCover != null) {
                calculateDCPremium = DCitems[1].amount / 1000 * data[i].dc / this.state.premium;
                calculateDCIsCheaper = DCitems[0].amount / 1000 * data[i].dc / this.state.premium;
                calculateDCIsExpensive = DCitems[2].amount / 1000 * data[i].dc / this.state.premium;

                DCitems[1].premium = this.roundToX(calculateDCPremium, 2);
                DCitems[0].premium = this.roundToX(calculateDCIsCheaper ,2);
                DCitems[2].premium = this.roundToX(calculateDCIsExpensive, 2);

                this.setState({data: data, age: this.props.userInputs.age, dc: data[i].dc, tpd: data[i].tpd});
              }
              if(this.props.insuranceCoverInputs.tpdCover != null) {
                calculateTPDPremium = TPDitems[1].amount / 1000 * data[i].tpd / this.state.premium;
                calculateTPDIsCheaper = TPDitems[0].amount / 1000 * data[i].tpd / this.state.premium;
                calculateTPDIsExpensive = TPDitems[2].amount / 1000 * data[i].tpd / this.state.premium;

                TPDitems[1].premium = this.roundToX(calculateTPDPremium, 2);
                TPDitems[0].premium = this.roundToX(calculateTPDIsCheaper, 2);
                TPDitems[2].premium = this.roundToX(calculateTPDIsExpensive, 2);
                this.setState({data: data, age: this.props.userInputs.age, dc: data[i].dc, tpd: data[i].tpd});
              }
              break;
            }
          }
        }


        const IPdata2y = require("!json!../../data/standardRateUnitisedTwoYear.json");
        const IPdata5y = require("!json!../../data/standardRateUnitisedFiveYear.json");
        const IPdata65y = require("!json!../../data/standardRateUnitisedSixtyFiveYear.json");

        if (this.props.userInputs.police == '0') {

            for (let j = 0; j < IPdata2y.length; j++) {
              if(IPdata2y[j].age === this.props.userInputs.age) {

                let RoundUpDecimal30 = IPdata2y[j].thirtyDay * ocData[i].IP;
                RoundUpDecimal30 = this.roundToX(RoundUpDecimal30, 2);

                let RoundUpDecimal60 = IPdata2y[j].sixtyDay * ocData[i].IP;
                RoundUpDecimal60 = this.roundToX(RoundUpDecimal60, 2);

                let RoundUpDecimal90 = IPdata2y[j].ninetyDay * ocData[i].IP;
                RoundUpDecimal90 = this.roundToX(RoundUpDecimal90, 2);

                calculateIP3Y30Day = this.props.insuranceCoverInputs.ipCover / 500 * RoundUpDecimal30 / this.state.premium;
                calculateIP3Y60Day =this.props.insuranceCoverInputs.ipCover / 500 * RoundUpDecimal60 / this.state.premium;
                calculateIP3Y90Day = this.props.insuranceCoverInputs.ipCover / 500 * RoundUpDecimal90 / this.state.premium;
              }
            }

            for (let k = 0; k < IPdata5y.length; k++) {
              if(IPdata5y[k].age === this.props.userInputs.age) {

                let RoundUpDecimal30 = IPdata5y[k].thirtyDay * ocData[i].IP;
                RoundUpDecimal30 = this.roundToX(RoundUpDecimal30, 2);

                let RoundUpDecimal60 = IPdata5y[k].sixtyDay * ocData[i].IP;
                RoundUpDecimal60 = this.roundToX(RoundUpDecimal60, 2);

                let RoundUpDecimal90 = IPdata5y[k].ninetyDay * ocData[i].IP;
                RoundUpDecimal90 = this.roundToX(RoundUpDecimal90, 2);


                calculateIP5Y30Day = this.props.insuranceCoverInputs.ipCover / 500 * RoundUpDecimal30 / this.state.premium;
                calculateIP5Y60Day =this.props.insuranceCoverInputs.ipCover / 500 * RoundUpDecimal60 / this.state.premium;
                calculateIP5Y90Day = this.props.insuranceCoverInputs.ipCover / 500 * RoundUpDecimal90 / this.state.premium;
              }
            }

            for (let l = 0; l < IPdata65y.length; l++) {
              if(IPdata65y[l].age === this.props.userInputs.age) {

                let RoundUpDecimal30 = IPdata65y[l].thirtyDay * ocData[i].IP;
                RoundUpDecimal30 = this.roundToX(RoundUpDecimal30, 2);

                let RoundUpDecimal60 = IPdata65y[l].sixtyDay * ocData[i].IP;
                RoundUpDecimal60 = this.roundToX(RoundUpDecimal60, 2);

                let RoundUpDecimal90 = IPdata65y[l].ninetyDay * ocData[i].IP;
                RoundUpDecimal90 = this.roundToX(RoundUpDecimal90, 2);

                calculateIP65Y30Day = this.props.insuranceCoverInputs.ipCover / 500 * RoundUpDecimal30 / this.state.premium;
                calculateIP65Y60Day =this.props.insuranceCoverInputs.ipCover / 500 * RoundUpDecimal60 / this.state.premium;
                calculateIP65Y90Day = this.props.insuranceCoverInputs.ipCover / 500 * RoundUpDecimal90 / this.state.premium;
              }
            }


            // set price for IP depending on selection
            if(this.props.insuranceCoverInputs.itemsWaitPeriod === '30') {
              IPitems[0].premium = this.roundToX(calculateIP3Y30Day, 2);
              IPitems[1].premium = this.roundToX(calculateIP5Y30Day, 2);
              IPitems[2].premium = this.roundToX(calculateIP65Y30Day, 2);
            } else if(this.props.insuranceCoverInputs.itemsWaitPeriod === '60') {
              IPitems[0].premium = this.roundToX(calculateIP3Y60Day ,2);
              IPitems[1].premium = this.roundToX(calculateIP5Y60Day, 2);
              IPitems[2].premium = this.roundToX(calculateIP65Y60Day, 2);
            } else if(this.props.insuranceCoverInputs.itemsWaitPeriod === '90') {
              IPitems[0].premium = this.roundToX(calculateIP3Y90Day, 2);
              IPitems[1].premium = this.roundToX(calculateIP5Y90Day, 2);
              IPitems[2].premium = this.roundToX(calculateIP65Y90Day, 2);
            }


          this.setState({
            amountIP: this.props.insuranceCoverInputs.ipCover
          });

      } else if(this.props.userInputs.police == '1' && this.props.insuranceCoverInputs.ipCover !== null) {
        // this.state.IPdata.length > 2 ? this.state.IPdata.splice(0, 1): null; 
        this.state.IPdata.length > 2 ? this.state.IPdata.splice(0, 1) : 2 == this.state.IPdata.length && this.state.IPdata.pop();
        let IPdata = require("!json!../../data/highRiskRateUnitisedPolice.json");
        for(let j = 0; j < IPdata.length; j++) {
          if(IPdata[j].age === this.props.userInputs.age) {
            calculateIPPolicePremium =this.props.insuranceCoverInputs.ipCover / 500 * IPdata[j].perUnit / this.state.premium;
            IPitems[0].premium = this.roundToX(calculateIPPolicePremium, 2);
            // SET THE PROTECTION LENGTH TO 2 years
            // IPitems[1].protectionLength = '2';
            this.setState({
              premiumIP: calculateIPPolicePremium
            });
          }
        }

        this.setState(update(this.state, {
          premiumIP: {$set: IPitems[0].premium}
        }));
      }
      }
    }
    this.updateFloatPanel();
  }

  updateFloatPanel(index){

    if(this.state.DCdata != undefined) {
      let DCnodes = this.state.DCdata,
          keys = Object.keys(DCnodes);
      for (let i = 0; i < keys.length; i++) {
        let DCnode = DCnodes[keys[i]];
        if (DCnode.checked) {
          this.setState({
            premiumDC: DCnode.premium,
            amountDC: DCnode.amount
          });
        }
      }
    }
    if(this.state.TPDdata != undefined) {
      let TPDnodes = this.state.TPDdata,
            keys = Object.keys(TPDnodes);
      for (let j = 0; j < keys.length; j++) {
        let TPDnode = TPDnodes[keys[j]];
        if (TPDnode.checked) {
          this.setState({
            premiumTPD: TPDnode.premium,
            amountTPD: TPDnode.amount
          });
        }
      }
    }

    if(this.state.IPdata != undefined) {
      let IPnodes = this.state.IPdata,
          keys = Object.keys(IPnodes);
      for (let k = 0; k < keys.length; k++) {
        let IPnode = IPnodes[keys[k]];
        if (IPnode.checked) {
          if(this.props.userInputs.police === '1') {
            this.setState({
              amountIP: IPnode.amount
            });
          } else {
            this.setState({
              premiumIP: IPnode.premium,
              amountIP: IPnode.amount
            });
          }
        }
      }
    }
  }


  update(e) {
    this.setState({
      amount: e.target.value
    });
  }

  handleTileSelectDC(val, index){

    this.state.DCdata.forEach((data) => {
      data.checked = false;
    });

    let DCdata = this.state.DCdata;
    DCdata[index].checked = val;
    this.setState({DCdata});

    if(this.state.DCdata[index].checked) {
      this.setState({
        premiumDC: this.state.DCdata[index].premium,
        amountDC: this.state.DCdata[index].amount
      });
    } else {
      this.setState({
        premiumDC: null,
        amountDC: null
      });
    }
  }

  handleTileSelectTPD(val, index){
    this.state.TPDdata.forEach((data) => {
      data.checked = false;
    });

    let TPDdata = this.state.TPDdata;
    TPDdata[index].checked=val;
    this.setState({TPDdata});

    if(this.state.TPDdata[index].checked){
      this.setState({
        premiumTPD: this.state.TPDdata[index].premium,
        amountTPD: this.state.TPDdata[index].amount
      });
    } else {
      this.setState({
        premiumTPD: null,
        amountTPD: null
      });
    }
  }

  handleTileSelectIP(val, index){
    this.state.IPdata.forEach((data) => {
      data.checked = false;
    });

    let IPdata = this.state.IPdata;
    IPdata[index].checked = val;
    this.setState({IPdata});

    if(this.props.userInputs.police != '0') {
      this.setState({
        IPprotectionLength: '2'
      });
    }

    if(this.state.IPdata[index].checked && this.props.userInputs.police !== '1') {
      this.setState({
        premiumIP: this.state.IPdata[index].premium,
        amountIP: this.state.IPdata[index].amount,
        IPprotectionLength: this.state.IPdata[index].protectionLength
      });
    } else if(this.state.IPdata[index].checked && this.props.userInputs.police !== '0') {
      this.setState({
        premiumIP: this.state.IPdata[index].premium,
        amountIP: this.state.IPdata[index].amount
      });
    } else {
      this.setState({
        premiumIP: null,
        amountIP: null
      });
    }
  }

  externalLinkClick(e) {
    ReactGA.event({
      category: 'Your premium estimate',
      action: 'User clicked external link',
      label: e.target.href
    });
  }

  enableNextButton() {

    if(this.props.userInputs.existingMember === '1') {
      return (
        <div className="panel--footer-links">
          <a onClick={this.externalLinkClick} href="https://memberonline.qsuper.qld.gov.au/your-super/super/insurance/" target="_blank" className="next-button cta">Manage your insurance in Member Online</a>
          {/* <a onClick={this.externalLinkClick} href="https://qinvest.com.au/contact-us/contact-us-financial-advice/" target="_blank" className={classnames('next-button cta', {inactive: this.props.step1Inactive})}>Speak to an advisor about your insurance needs</a> */}
        </div>
      );
    } else {
      return (
        <a onClick={this.externalLinkClick} href="https://qsuper.qld.gov.au/our-products/why-qsuper" target="_blank" className={classnames('next-button cta', {inactive: this.props.step1Inactive})}>More great reasons to become a QSuper member</a>
      );
    }
  }


  render() {

        const DCtiles = this.state.DCdata.map((item, index, val) => {
          return (<Tile
          frequency={this.state.premiumFrequency}
          checked={item.checked}
          index={index}
          handleChange={this.handleTileSelectDC}
          onToggle={this.onChildToggle}
          selected={this.state.selections[item.id]}
          key={item.key}
          amount={item.amount}
          item={item.id}
          results={item.premium.toLocaleString(undefined, {minimumFractionDigits:2})}
          tileType={item.tileType}
          id={item.id}
          insuranceInputs={this.props.insuranceCoverInputs}
          />);
        });

        const TPDtiles = this.state.TPDdata.map((item, index, val) => {
          return (<Tile
          frequency={this.state.premiumFrequency}
          checked={item.checked}
          index={index}
          handleChange={this.handleTileSelectTPD}
          onToggle={this.onChildToggle}
          selected={this.state.selections[item.id]}
          key={item.key}
          amount={item.amount}
          item={item.id}
          results={item.premium.toLocaleString(undefined, {minimumFractionDigits:2})}
          tileType={item.tileType}
          id={item.id}
          insuranceInputs={this.props.insuranceCoverInputs}
          />);
        });

        const IPtiles = this.state.IPdata.map((item, index) => {
          return (
            <Tile
              frequency={this.state.premiumFrequency}
              key={item.key}
              amount={item.amount}
              item={item.id}
              checked={item.checked}
              handleChange={this.handleTileSelectIP}
              index={index}
              results={item.premium.toLocaleString(undefined, {minimumFractionDigits:2})}
              tileType={item.tileType}
              id={item.id}
              protectionLength={item.protectionLength}
              userInputs={this.props.userInputs}
              insuranceInputs={this.props.insuranceCoverInputs} />
          );              
        });


    return (

      <div className={classnames('panel', {inactive: this.props.step3Inactive})}>
        <div className="panel--title">
          <h2>3. Your premium estimate</h2>
        </div>
      <div className="panel--content">
        <p>Here's an estimate based on the cover amounts you told us. We've also added some alternatives based on higher and lower levels of cover</p>

        {this.props.insuranceCoverInputs.deathCover > 1
        ? (<div>
          <div className="death-cover hidden-small-and-below"><span className="dc-icon"></span><h3>Death cover</h3><div className="tile-container">{DCtiles}</div></div>
          <Collapsible trigger={<span>Death cover premiums <span className="premium">{this.state.premiumDC != null ? '$' + this.state.premiumDC.toLocaleString(undefined, {minimumFractionDigits:2}) : null}</span></span>} className="hidden-medium-and-above" openedClassName="hidden-medium-and-above">
            <Carousel>
              {DCtiles}
            </Carousel>
          </Collapsible>
          </div>
        )
        : null}

        {this.props.insuranceCoverInputs.tpdCover > 1
        ? (<div>
            <div className="tpd-cover hidden-small-and-below"><span className="tpd-icon"></span><h3>Total and Permanent Disability cover</h3><div className="tile-container">{TPDtiles}</div></div>
            <Collapsible trigger={<span>TPD cover premiums <span className="premium">{this.state.premiumTPD != null ? '$' + this.state.premiumTPD.toLocaleString(undefined, {minimumFractionDigits:2}) : null}</span></span>} className="hidden-medium-and-above" openedClassName="hidden-medium-and-above">
              <Carousel>
                {TPDtiles}
              </Carousel>
            </Collapsible>
          </div>
          )
        : null}

        {this.props.insuranceCoverInputs.ipCover > 1
        ? (<div>
          <div className="ip-cover hidden-small-and-below"><span className="ip-icon"></span><h3>Income Protection cover</h3><div className="tile-container">{IPtiles}</div></div>
          <Collapsible trigger={<span>IP cover premiums <span className="premium">{this.state.premiumIP != null ? '$' + this.state.premiumIP.toLocaleString(undefined, {minimumFractionDigits:2}) : null}</span></span>} className="hidden-medium-and-above" openedClassName="hidden-medium-and-above">
            <Carousel >
              {IPtiles}
            </Carousel>
          </Collapsible>
          </div>
        )
        : null}
        </div>

        {
          (this.state.amountDC || this.state.amountTPD || this.state.amountIP) && (this.props.step3Inactive == false)
          ? (
            <FloatPanel
              handlePremiumChange={this.handlePremiumChange}

              DCpremium={this.state.premiumDC}
              DCamount={this.state.amountDC}

              TPDpremium={this.state.premiumTPD}
              TPDamount={this.state.amountTPD}

              IPpremium={this.state.premiumIP}
              IPamount={this.state.amountIP}
              IPprotectionLength={this.state.IPprotectionLength}

              insuranceCoverInputs={this.props.insuranceCoverInputs}

              frequency={this.state.premiumFrequency}
              premium ={this.state.premium}
            />
          ) : null
        }
        {
          !this.props.step3Inactive
          ? this.enableNextButton()
          : null
        }
      </div>
    );
  }
}

CompareCover.defaultProps={
  userInputs: {
    age: '',
    police: ''
  }
};

CompareCover.propTypes = {
  step1Inactive: React.PropTypes.bool.isRequired,
  step3Inactive: React.PropTypes.bool.isRequired,
  insuranceCoverInputs: React.PropTypes.shape({
      // title: React.PropTypes.string
      deathCover: React.PropTypes.string,
      tpdCover: React.PropTypes.string,
      ipCover: React.PropTypes.string,
      // itemsProtectionLength: React.PropTypes.string,
      // itemsWaitPeriod: React.PropTypes.string
    }),
    userInputs: React.PropTypes.shape({
        // title: React.PropTypes.string
        age: '',
        police: '',
        existingMember: '',
        occupationalRating: ''
      })
};

export default CompareCover;



// WEBPACK FOOTER //
// ./src/components/panels/CompareCover.js